import {
   // GET_INPATIENT_CLAIM_OPTIONS_SUCCESS,
   // GET_INPATIENT_CLAIM_OPTIONS_ERROR,
   GET_CLAIM_OPTIONS_SUCCESS,
   GET_CLAIM_OPTIONS_ERROR
} from "../actions";

const initialState = {
   inpatientClaimOptions: null,
   outpatientClaimOptions: null
};

export default function(state = initialState, action) {
   switch (action.type) {
      case GET_CLAIM_OPTIONS_SUCCESS:
         return Object.assign(
            {},
            { ...state },
            {
               inpatientClaimOptions: action.payload.data.claimoptions.inpatientClaimConfig,
               outpatientClaimOptions: action.payload.data.claimoptions.outpatientClaimConfig
            }
         );
      case GET_CLAIM_OPTIONS_ERROR:
         return Object.assign(
            {},
            { ...state },
            {
               inpatientClaimOptions: [],
               outpatientClaimOptions: []
            }
         );
      // case GET_INPATIENT_CLAIM_OPTIONS_SUCCESS:
      //   return Object.assign({}, { ...state }, { inpatientClaimOptions: action.payload.data });
      // case GET_INPATIENT_CLAIM_OPTIONS_ERROR:
      //   return state;
      default:
         return state;
   }
}
